import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';

function toBlob(uri) {
  const data = uri.split(',')[1];
  const bytes = atob(data);
  const bytesArray = new Uint8Array(bytes.length);

  for (let i = 0; i < bytes.length; i++) {
    bytesArray[i] = bytes.charCodeAt(i);
  }

  return new File([new Blob([bytesArray], { type: 'image/png' })], 'avatar.png');
}

function App({ inputRef, liveView, circularCrop }) {
  const [src, setSrc] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [crop, setCrop] = useState(null);
  const imgRef = useRef(null);

  const onSelectFile = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => setSrc(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const onImageLoad = (e) => {
    imgRef.current = e.currentTarget;

    const initialCrop = {
      unit: 'px',
      x: 50,
      y: 50,
      width: 100,
      height: 100,
    };

    setCrop(initialCrop);
    saveCroppedImage(initialCrop);
  };

  const saveCroppedImage = (crop) => {
    if (imgRef.current && crop.width && crop.height) {
      const canvas = document.createElement('canvas');
      const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
      const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        imgRef.current,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      const croppedImage = canvas.toDataURL('image/png');
      const file = toBlob(croppedImage);
      const fileInput = document.querySelector(`#${inputRef}`);

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInput.files = dataTransfer.files;

      liveView.upload(fileInput.name, [file]);
    }
  };

  const onCropChange = (newCrop) => {
    setCrop(newCrop);
    if (newCrop.width && newCrop.height) {
      saveCroppedImage(newCrop);
    }
  };

  return (
    <div className="space-y-2">
      <label className="font-medium focus:outline-hidden focus:ring-2 focus:ring-offset-2 px-3.5 py-1 text-sm shadow-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:ring-gray-500 focus:border-gray-500 mt-2 rounded-full cursor-pointer">
        Select Image
        <input
          type="file"
          accept="image/*"
          onChange={onSelectFile}
          className="hidden"
        />
      </label>
      {fileName && (
        <span className="ml-2 text-sm text-gray-500">{fileName}</span>
      )}
      {src && (
        <ReactCrop
          crop={crop}
          aspect={1}
          onChange={onCropChange}
          circularCrop={circularCrop}
        >
          <img src={src} onLoad={onImageLoad} alt="Crop me" />
        </ReactCrop>
      )}
    </div>
  );
}

App.propTypes = {
  inputRef: PropTypes.any,
  liveView: PropTypes.object,
  circularCrop: PropTypes.bool,
};

export default {
  mounted() {
    const inputRef = this.el.getAttribute('data-phx-upload-ref');
    const circularCrop = this.el.getAttribute('data-circular-crop') === 'true';
    ReactDOM.render(<App inputRef={inputRef} liveView={this} circularCrop={circularCrop}/>, this.el);
  },
};
